// extracted by mini-css-extract-plugin
export var compactFilters = "_fo-4";
export var detailImage = "_fo-1";
export var dropdownContainer = "_fo-2";
export var imageContainer = "_fo-0";
export var selectedCard = "_fo-3";